import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';

interface ParameterSelectDropdownProps {
  selectedParameterName: string;
  parameterList: { name: string }[];
  handleParameterChange: (event: SelectChangeEvent<string>) => void;
}

export const ParameterSelectDropdown: React.FC<ParameterSelectDropdownProps> = ({
  selectedParameterName,
  parameterList,
  handleParameterChange,
}) => (
  <Box component="div" sx={{ flex: 1 }}>
    <FormControl
      size="small"
      sx={{
        width: '100%',
        backgroundColor: '#404040',
        borderRadius: 1,
      }}
    >
      <InputLabel
        id="config-name-select-label"
        sx={{
          color: '#f0f0f0',
          fontSize: '12px',
        }}
      >
        Select Parameter
      </InputLabel>
      <Select
        labelId="config-name-select-label"
        id="config-name-select"
        value={selectedParameterName}
        onChange={handleParameterChange}
        label="Select Parameter"
        sx={{
          color: '#f0f0f0',
          fontSize: '12px',
          '.MuiSvgIcon-root': { color: '#f0f0f0' },
        }}
      >
        {parameterList.map((config, index) => (
          <MenuItem
            key={index}
            value={config.name}
            onClick={() => handleParameterChange({ target: { value: config.name } } as SelectChangeEvent<string>)}
          >
            {config.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
);
